import React from 'react';
import type { Tone } from './useHomeData';

export const DemoChip = () => (
  <span title="Số liệu mẫu – chưa có API" className="rounded-full bg-amber-400/15 px-1.5 py-px text-[10px] font-semibold text-amber-300">Mẫu</span>
);

export function Card({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return <section className={`rounded-2xl border border-white/[0.08] bg-slate-900/70 shadow-2xl shadow-black/20 backdrop-blur-xl ${className}`}>{children}</section>;
}

export function CardHead({ title, count, extra, demo }: { title: React.ReactNode; count?: number; extra?: React.ReactNode; demo?: boolean }) {
  return (
    <div className="flex items-center gap-2 px-4 pb-2 pt-3">
      <h3 className="text-[13px] font-semibold text-white">{title}</h3>
      {!!count && <span className="rounded-full bg-white/10 px-1.5 text-[11px] font-semibold tabular-nums text-slate-200">{count}</span>}
      {demo && <DemoChip />}
      <span className="flex-1" />
      {extra}
    </div>
  );
}

export const TONE_TILE: Record<Tone, string> = {
  danger: 'bg-rose-500/15 text-rose-300',
  warn: 'bg-amber-500/15 text-amber-300',
  info: 'bg-sky-500/15 text-sky-300',
  ok: 'bg-emerald-500/15 text-emerald-300',
};
export const TONE_TEXT: Record<Tone, string> = {
  danger: 'text-rose-300',
  warn: 'text-amber-300',
  info: 'text-sky-300',
  ok: 'text-emerald-300',
};

/** Vòng tiến độ chỉ tiêu */
export function Ring({ pct, size = 92, stroke = 8 }: { pct: number; size?: number; stroke?: number }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const p = Math.max(0, Math.min(100, pct));
  const color = p >= 100 ? '#34d399' : p >= 70 ? '#2dd4bf' : p >= 40 ? '#fbbf24' : '#fb7185';
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke={color} strokeWidth={stroke} fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - p / 100)} style={{ transition: 'stroke-dashoffset .6s ease' }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-xl font-semibold tabular-nums text-white">{Math.round(p)}%</span>
        <span className="-mt-0.5 text-[10px] text-slate-400">chỉ tiêu</span>
      </div>
    </div>
  );
}
